import React, { useState } from "react";
import { getCurrentAgentInfo, login } from "./odooRpc";
import { useNavigate } from "react-router-dom";
import { fetchSession } from "./session";
import { FaArrowRight, FaEye, FaEyeSlash, FaLock, FaUser } from "react-icons/fa";

export default function Login({ onLogin }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await login(username, password);

      if (response?.uid) {
        const session = await fetchSession().catch(() => null);
        await getCurrentAgentInfo().catch(() => null);
        localStorage.setItem("email", session?.email || username);
        onLogin(response); // parent callback
        navigate("/");      // redirect to dashboard
      } else {
        setError("Login failed: UID not returned.");
      }
    } catch (err) {
      console.error("Login error:", err.message);
      setError("Login failed: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* ✅ Full-Screen Loading Overlay */}
      {loading && (
        <div className="loader-overlay">
          <div className="spinner" />
        </div>
      )}

      <div className="login-page">
        <div className="login-backdrop login-backdrop-one" />
        <div className="login-backdrop login-backdrop-two" />
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="login-brand">
            <img src="/Mslogo.svg" alt="Logo" className="login-logo" />
            <div className="login-kicker">Mystock Agent Portal</div>
            <h2>Sign in to your dashboard</h2>
            <p className="login-copy">
              Track sales, refunds, customers, and commission from one place.
            </p>
          </div>

          {error && <div className="login-error">{error}</div>}

          <label className="login-field">
            <span className="login-label">Email</span>
            <div className="login-input-wrap">
              <FaUser className="login-input-icon" />
              <input
                type="text"
                placeholder="Enter your email"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="login-input"
                disabled={loading}
                autoComplete="username"
              />
            </div>
          </label>

          <label className="login-field">
            <span className="login-label">Password</span>
            <div className="login-input-wrap login-input-wrap-password">
              <FaLock className="login-input-icon" />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="login-input login-input-password"
                disabled={loading}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword((current) => !current)}
                disabled={loading}
                aria-label={showPassword ? "Hide password" : "Show password"}
                aria-pressed={showPassword}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
          </label>

          <button type="submit" className="login-button" disabled={loading}>
            <span>{loading ? "Logging in..." : "Login"}</span>
            {!loading ? <FaArrowRight className="login-button-icon" /> : null}
          </button>

          <div className="login-footer">
            <span
              onClick={() =>
                window.location.href = "https://stocknow.odoo.com/web/reset_password"
              }
              className="login-forgot-link"
            >
              Forgot Password?
            </span>
          </div>
        </form>
      </div>
    </>
  );
}
